var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.94864 1.47297C5.50084 1.47297 5.13783 1.83599 5.13783 2.28378V3.09459H9.35405V2.28378C9.35405 1.83599 8.99103 1.47297 8.54324 1.47297H5.94864ZM10.327 3.09459V2.28378C10.327 1.29863 9.52839 0.5 8.54324 0.5H5.94864C4.96348 0.5 4.16486 1.29863 4.16486 2.28378V3.09459H2.7054C1.72024 3.09459 0.921614 3.89322 0.921614 4.87838V7.46248C0.921473 7.46923 0.921474 7.47597 0.921614 7.4827V10.7162C0.921614 11.7014 1.72024 12.5 2.7054 12.5H11.7865C12.7716 12.5 13.5703 11.7014 13.5703 10.7162V7.48269C13.5704 7.47597 13.5704 7.46923 13.5703 7.46249V4.87838C13.5703 3.89322 12.7716 3.09459 11.7865 3.09459H10.327ZM2.7054 4.06757C2.2576 4.06757 1.89459 4.43058 1.89459 4.87838V7.16939C5.28081 8.77584 9.21107 8.77584 12.5973 7.16939V4.87838C12.5973 4.43058 12.2343 4.06757 11.7865 4.06757H2.7054ZM12.5973 8.23769C9.18407 9.71703 5.3078 9.71703 1.89459 8.23769V10.7162C1.89459 11.164 2.2576 11.527 2.7054 11.527H11.7865C12.2343 11.527 12.5973 11.164 12.5973 10.7162V8.23769ZM7.24594 6.33784C7.51462 6.33784 7.73243 6.55565 7.73243 6.82433V6.83081C7.73243 7.09949 7.51462 7.3173 7.24594 7.3173C6.97726 7.3173 6.75945 7.09949 6.75945 6.83081V6.82433C6.75945 6.55565 6.97726 6.33784 7.24594 6.33784Z",
    fill: "#5E6C84",
    stroke: "#5E6C84",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.6337b78406ddec0f0082e43bcd804490.svg";
export { ForwardRef as ReactComponent };